/** 与核心对战机制文档一一对应的调度时机。 */
export enum Timing {
    /**
     * battleBegin，保存当前实例的battleBegin状态。
     */
    battleBegin = "battleBegin",
    /**
     * petOn，保存当前实例的petOn状态。
     */
    petOn = "petOn",
    /**
     * petOff，保存当前实例的petOff状态。
     */
    petOff = "petOff",
    /**
     * roundBegin，保存当前实例的roundBegin状态。
     */
    roundBegin = "roundBegin",
    /**
     * battleStageBegin，保存当前实例的battleStageBegin状态。
     */
    battleStageBegin = "battleStageBegin",
    /**
     * actionBegin，保存当前实例的actionBegin状态。
     */
    actionBegin = "actionBegin",
    /**
     * onUseSkill，保存当前实例的onUseSkill状态。
     */
    onUseSkill = "onUseSkill",
    /**
     * beforeSkillHit，保存当前实例的beforeSkillHit状态。
     */
    beforeSkillHit = "beforeSkillHit",
    /**
     * onSkillHit，保存当前实例的onSkillHit状态。
     */
    onSkillHit = "onSkillHit",
    /**
     * onSkillMiss，保存当前实例的onSkillMiss状态。
     */
    onSkillMiss = "onSkillMiss",
    /**
     * beforeDamage，保存当前实例的beforeDamage状态。
     */
    beforeDamage = "beforeDamage",
    /**
     * onDamage，保存当前实例的onDamage状态。
     */
    onDamage = "onDamage",
    /**
     * afterUseSkill，保存当前实例的afterUseSkill状态。
     */
    afterUseSkill = "afterUseSkill",
    /**
     * actionEnd，保存当前实例的actionEnd状态。
     */
    actionEnd = "actionEnd",
    /**
     * battleStageEnd，保存当前实例的battleStageEnd状态。
     */
    battleStageEnd = "battleStageEnd",
    /**
     * roundEnd，保存当前实例的roundEnd状态。
     */
    roundEnd = "roundEnd",
    /**
     * afterRoundEnd，保存当前实例的afterRoundEnd状态。
     */
    afterRoundEnd = "afterRoundEnd",
    /**
     * petDead，保存当前实例的petDead状态。
     */
    petDead = "petDead",
    /**
     * onDefeat，保存当前实例的onDefeat状态。
     */
    onDefeat = "onDefeat",
    /**
     * buffChanged，保存当前实例的buffChanged状态。
     */
    buffChanged = "buffChanged",
    /**
     * triggered，保存当前实例的triggered状态。
     */
    triggered = "triggered",
    /**
     * untriggered，保存当前实例的untriggered状态。
     */
    untriggered = "untriggered",
}

/**
 * timingLabels，供本模块相关规则使用。
 */
export const timingLabels: Record<Timing, string> = {
    battleBegin: "战斗开始",
    petOn: "精灵登场",
    petOff: "主动下场",
    roundBegin: "回合开始",
    battleStageBegin: "战斗阶段开始",
    actionBegin: "出手开始",
    onUseSkill: "使用技能",
    beforeSkillHit: "技能命中前",
    onSkillHit: "技能命中",
    onSkillMiss: "技能未命中",
    beforeDamage: "造成伤害前",
    onDamage: "造成伤害",
    afterUseSkill: "使用技能后",
    actionEnd: "出手结束",
    battleStageEnd: "战斗阶段结束",
    roundEnd: "回合结束",
    afterRoundEnd: "回合结束后",
    petDead: "精灵阵亡",
    onDefeat: "击败对手",
    buffChanged: "Buff变化",
    triggered: "效果触发成功",
    untriggered: "效果未触发",
};
